module.exports = __webpack_public_path__ + "static/tolleson-a88b2cda52c847c459f78422c4ea77b1.png";